import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import CitationCell from '@Components/Results/substances/tables/cells/citation-cell.component';
import DataCell from '@Components/Results/substances/tables/cells/data-cell.component';
import NumberFormatter from '@Utils/NumberFormatter';
import { CITATION_LINKS_TRACKING_INDEX_MARKER } from '@Components/Results/analytics/citationLinksTracking';

function renderCell(cell, metadata) {
  if (cell.id !== 'citation') {
    return <DataCell data={cell.value} />;
  }
  return <CitationCell metadata={metadata} citations={cell.value} />;
}

export default class SubstanceQuantitativeReport extends React.PureComponent {
  render() {
    const { metadata, data, total } = this.props;

    return (
      <div className="quantitative-information">
        {data.map((report, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={index} className="quantitative-information__item">
            <div className="quantitative-information__count">
              {NumberFormatter(index + 1, 0)} of {NumberFormatter(total, 0)}
            </div>

            {report.length > 0 && (
              <div className="quantitative-information__table-wrap">
                <table className="quantitative-information__table table c-els-table c-els-table--subtle-dividers">
                  <caption className="c-els-table__caption u-els-hide-visually">
                    Quantitative result {NumberFormatter(index + 1, 0)} of {NumberFormatter(total, 0)}
                  </caption>
                  <tbody className="table__body c-els-table__body">
                    {report.map(
                      (item) =>
                        item.field.value &&
                        item.field.value?.length > 0 && (
                          <tr
                            className="table__row c-els-table__row"
                            key={`${item.header?.title}-${item.field?.id}`}
                            {...CITATION_LINKS_TRACKING_INDEX_MARKER.substancesTableItem}>
                            <InnerHTML
                              className="table__cell c-els-table__cell c-els-table__basic-cell table__cell--header c-els-table__cell--header quantitative-information__label-cell"
                              tag="th"
                              scope="row"
                              html={item.header?.title}
                            />

                            <td className="table__cell c-els-table__cell c-els-table__basic-cell quantitative-information__value-cell">
                              {renderCell(item.field, metadata)}
                            </td>
                          </tr>
                        )
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        ))}
      </div>
    );
  }
}

SubstanceQuantitativeReport.propTypes = {
  metadata: MetadataPropTypesShape,
  data: PropTypes.array.isRequired,
  total: PropTypes.number.isRequired,
};
